import { addScript } from "../../bundles/helpers/add-script";
(async () => {
    if (!window.Swiper) await addScript(PUBLIC_PATH + 'vendor/swiper.vendor.js');
    Array.prototype.forEach.call(document.getElementsByClassName('swiper-row'), (elem) => {
        new Swiper(elem, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            slidesPerColumn: elem.dataset.row ? elem.dataset.row : 1,
            watchSlidesVisibility: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: true,
            },
            navigation: {
                nextEl: elem.getElementsByClassName('swiper-row__button_next'),
                prevEl: elem.getElementsByClassName('swiper-row__button_prev'),
            },
            pagination: {
                el: elem.getElementsByClassName('swiper-pagination'),
                type: 'bullets',
                clickable: true,
            },
        });
    });
})();
